export default __webpack_public_path__ + "static/media/Prozess.97ec4e68.png";